import HOW_TO_COMPLETE_BACKGROUND from '../assets/Images/how_to_complete.svg';
import KIDNEYS from '../assets/Images/kidneys.svg';
import NOTE_ICON from '../assets/Images/note_icon.svg';
import LOGO from '../assets/Images/LogoBayer.png';
import AVATAR from '../assets/Images/avatar.png';
import FOOTER_IMAGE from '../assets/Images/LogoKlinriskKOutline.svg';
import RED_KIDNEY from '../assets/Images/RedKidneys.svg';
import YELLOW_KIDNEY from '../assets/Images/YellowKidneys.svg';
import BROKEN_HEART from '../assets/Images/brokenHeart.png';
import HEALTHY_HEART from '../assets/Images/healthyHeart.png';
import GRAPH1 from '../assets/Images/Graphs/Graph1.svg';
import GRAPH2 from '../assets/Images/Graphs/Graph2.svg';
import GRAPH3 from '../assets/Images/Graphs/Graph3.svg';
import GRAPH4 from '../assets/Images/Graphs/Graph4.svg';
import GRAPH5 from '../assets/Images/Graphs/Graph5.svg';
import GRAPH6 from '../assets/Images/Graphs/Graph6.svg';
import GRAPH7 from '../assets/Images/Graphs/Graph7.svg';
import GRAPH8 from '../assets/Images/Graphs/Graph8.svg';
import GRAPH9 from '../assets/Images/Graphs/Graph9.svg';
import GRAPH10 from '../assets/Images/Graphs/Graph10.svg';
import GRAPH11 from '../assets/Images/Graphs/Graph11.svg';
import GRAPH12 from '../assets/Images/Graphs/Graph12.svg';

import TTD_ARROW from '../assets/Images/DynamicChartAssets/TTDArrow.svg';
import TTD_LEGEND_ARROW from '../assets/Images/DynamicChartAssets/TTDLegendArrow.svg';
import UPPER_RESULTS_REGION from '../assets/Images/DynamicChartAssets/UpperBar.svg';
import LOWER_RESULTS_REGION from '../assets/Images/DynamicChartAssets/LowerBar.svg';
import TREATMENT_ARROW from '../assets/Images/DynamicChartAssets/TreatmentArrow.svg';

export const DYNAMIC_GRAPH_IMAGES = {
  TTD_ARROW,
  TTD_LEGEND_ARROW,
  UPPER_RESULTS_REGION,
  LOWER_RESULTS_REGION,
  TREATMENT_ARROW,
};

const TEXT = {
  LOGO: LOGO,
  NAME: 'Act Early on Chronic Kidney Disease Treatment',
  INFORMATION_BUTTON: 'Key Assumptions & References',
  WELCOME_TITLE: 'Welcome.',
  WELCOME_TEXT:
    'Explore how your treatment approach can influence the progression of kidney disease and benefit ' +
    'your patients.',
  BEGIN_ACTIVITY_BUTTON: 'Begin the activity',
  BEGIN_ACTIVITY_NOTE: 'Approximate time to complete:',
  BEGIN_ACTIVITY_TIME: '~5 Minutes',
  HOW_THIS_MODEL_WORKS: 'How does this model work?',
  HOW_THIS_MODEL_WORKS_TEXT1:
    'This model uses data from clinical trials to predict the effect of intervention timing and intensity on kidney outcomes with various therapies and combinations.',
  HOW_THIS_MODEL_WORKS_TEXT2:
    'Using these modeled data, discover the optimal methods for improving CKD outcomes, and witness the impact of the timing of intervention on the expected time till dialysis initiation.',
  HOW_TO_COMPLETE_BACKGROUND: HOW_TO_COMPLETE_BACKGROUND,
  KIDNEYS: KIDNEYS,
  NOTEICON: NOTE_ICON,
  HOW_TO_COMPLETE: 'How to complete',
  CHOICES_HEADING: 'You will be presented with a panel of choices about:',
  CHOICE1: 'Risk of CKD Progression',
  CHOICE2: 'Type of treatment',
  CHOICE3: 'Timing of intervention',
  CHOICES_NOTE:
    'Select any of combination of these choices to see the predicted trajectory.',
  AVATAR: AVATAR,
  COLLABORATION_HEADING: 'Developed in collaboration with:',
  DR_NAME: 'Dr. Navdeep Tangri',
  DR_STUDY: 'MD, PhD, FRCP',
  DR_ADDRESS: 'University of Manitoba, Winnipeg, MB. Canada',
  FOOTER_IMAGE: FOOTER_IMAGE,
  FOOTER_INSTRUCTIONS:
    'Act Early on Chronic Kidney Disease Treatment. Copyright 2025.',
  FOOTER_INSTRUCTIONS2:
    'This activity was developed by the Chronic Disease Innovation Center through support from',
  FOOTER_INSTRUCTIONS3:
    ' an unrestricted educational grant provided by Bayer AG.',
  QUESTIONNAIRE: {
    LABEL1: "Select the patient's risk of CKD progression.",
    RED_KIDNEY: RED_KIDNEY,
    YELLOW_KIDNEY: YELLOW_KIDNEY,
    INTERMEDIATE_RISK: 'Intermediate risk',
    HIGH_RISK: 'High risk',
    LABEL2: 'Select the treatment plan.',
    RAAS_INHIBITOR: 'RASi',
    RAAS_INHIBITOR_AND_SGLT2_INHIBITOR: 'RASi + SGLT2i',
    RAAS_INHIBITOR_AND_SGLT2_INHIBITOR_AND_NSMRA: 'RASi + SGLT2i + MRA',
    RAAS_INHIBITOR_AND_SGLT2_INHIBITOR_AND_GLP1RA: 'RASi + SGLT2i + GLP-1',
    FOUR_DRUG_THERAPY: 'RASi + SGLT2i + MRA + GLP-1',
    LABEL3: 'Current eGFR',
    LATE_INTERVENTION: 'Late intervention',
    LATE_INTERVENTION_FOOTNOTE: '(eGFR ~40 mL/min/1.73 m<sup>2</sup>',
    EARLY_INTERVENTION: 'Early intervention',
    EARLY_INTERVENTION_FOOTNOTE: '(eGFR ~80 mL/min/1.73 m<sup>2</sup>',
    LABEL4: 'Current age',
  },
  AGE_QUESTION: {
    LABEL: 'Enter the patient’s current age.',
    YEARS: 'years',
  },
  REDUX: {
    SET_ANSWER: 'SET_ANSWER',
    RISK: 'RISK',
    TREATMENT_PLAN: 'TREATMENT_PLAN',
    TREATMENT_TIMING: 'TREATMENT_TIMING',
    INITIAL_AGE: 'INITIAL_AGE',
  },
  GRAPH_IMAGES: {
    1: GRAPH1,
    2: GRAPH2,
    3: GRAPH3,
    4: GRAPH4,
    5: GRAPH5,
    6: GRAPH6,
    7: GRAPH7,
    8: GRAPH8,
    9: GRAPH9,
    10: GRAPH10,
    11: GRAPH11,
    12: GRAPH12,
  },
  BROKEN_HEART: BROKEN_HEART,
  HEALTHY_HEART: HEALTHY_HEART,
  PRINT_BUTTON_TEXT: 'Print Results',
  PDF_FILE_NAME: 'Act-Early-on-Chronic-Kidney-Disease-Treatment.pdf',
  GRAPH_HEADER: 'Your Results',
  RESULTS_SUMMARY_DIALYSIS_ALT: 'Results Summary - Dialysis',
  RESULTS_SUMMARY_HEART_FAILURE_ALT: 'Results Summary - Heart Failure',
  INITIAL_EGFR_SLIDER_LABEL: 'Initial eGFR:',
  CURRENT_AGE_SLIDER_LABEL: 'Current Age:',
  GRAPH_ALT: 'Prolonged Dialysis Results Graph',
};

export default TEXT;
